import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';

const QuoteForm = () => {
  const initialFormData = {
    name: '',
    email: '',
    phone: '',
    city: '',
    type: '',
    fragile: false,
    express: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [validator] = useState(new SimpleReactValidator());

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });

    validator.showMessageFor(name);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validator.allValid()) {
      toast.success('Your quote request has been submitted successfully.');

      setFormData(initialFormData);
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  return (
    <form id='quoteForm' onSubmit={handleSubmit}>
      <div className='row'>
        <div className='item col-lg-12'>
          <label>Personal information</label>
          <input
            className='form-control'
            type='text'
            name='name'
            id='name'
            placeholder='Your Name'
            value={formData.name}
            onChange={handleChange}
            required
          />
          {validator.message('name', formData.name, 'required|alpha_space')}
        </div>

        <div className='item col-lg-6 col-12'>
          <input
            className='form-control'
            type='email'
            name='email'
            id='email'
            placeholder='Email'
            value={formData.email}
            onChange={handleChange}
            required
          />
          {validator.message('email', formData.email, 'required|email')}
        </div>

        <div className='item col-lg-6 col-12'>
          <input
            className='form-control'
            type='text'
            name='phone'
            id='phone'
            placeholder='Phone'
            value={formData.phone}
            onChange={handleChange}
            required
          />
          {validator.message('phone', formData.phone, 'required|phone')}
        </div>

        <div className='item col-lg-12'>
          <label>Delivery information</label>
          <input
            className='form-control'
            type='text'
            name='city'
            id='city'
            placeholder='Delivery City'
            value={formData.city}
            onChange={handleChange}
            required
          />
          {validator.message('city', formData.city, 'required')}
        </div>

        <div className='item col-lg-12'>
          <label>Freight Type</label>
          <select
            name='type'
            id='type'
            className='form-control'
            value={formData.type}
            onChange={handleChange}
            required
          >
            <option value=''>Freight Type</option>
            <option value='road-freight'>Road Freight</option>
            <option value='air-freight'>Air Freight</option>
            <option value='ocean-freight'>Ocean Freight</option>
            <option value='warehousing'>Warehousing</option>
          </select>
          {validator.message('type', formData.type, 'required')}
        </div>

        <div className='item col-8'>
          <ul>
            <li>
              <input
                type='checkbox'
                id='fragile'
                name='fragile'
                checked={formData.fragile}
                onChange={handleChange}
              />
              <label htmlFor='fragile'>Fragile</label>
            </li>

            <li>
              <input
                type='checkbox'
                id='express'
                name='express'
                checked={formData.express}
                onChange={handleChange}
              />
              <label htmlFor='express'>Express delivery</label>
            </li>
          </ul>
        </div>

        <div className='item col-12'>
          <input className='theme-btn' type='submit' value='Get A Quote' />
        </div>
      </div>
    </form>
  );
};

export default QuoteForm;
